<template>
  <a
    v-if="url"
    class="link-button"
    @click="pushEvent"
    :style="styles"
    :href="url"
    target="_blank"
  >
    <icon
      v-if="iconBefore"
      class="link-button-icon"
      :data="iconBefore"
      color="var(--icon-color)"
      width="24"
      height="24" />
    {{ label }}
    <icon
      v-if="iconAfter"
      class="link-button-icon"
      :data="iconAfter"
      color="var(--icon-color)"
      width="24"
      height="24"
  /></a>
  <button v-else class="link-button" :style="styles" @click="$emit('onClick')">
    <icon
      v-if="iconBefore"
      class="link-button-icon"
      :data="iconBefore"
      color="var(--icon-color)"
      width="24"
      height="24"
    />
    {{ label }}
    <icon
      v-if="iconAfter"
      class="link-button-icon"
      :data="iconAfter"
      color="var(--icon-color)"
      width="24"
      height="24"
    />
  </button>
</template>

<script setup>
import { pushData } from "@/utilities/analytics-functions.js";

const props = defineProps({
  label: String,
  iconBefore: Object,
  iconAfter: Object,
  url: String,
  styles: Object,
  componentTitle: { type: String, default: "", required: false },
  componentType: { type: String, default: "", required: false },
});

function pushEvent() {
  pushData({
    event: "externalLink",
    eventType: "",
    componentType: props.componentType,
    componentTitle: props.componentTitle,
    componentLink: props.url,
    componentLinkText: props.label,
  });
}
</script>

<style lang="scss" scoped>
.link-button {
  @include overlay-m;
  height: toRem(56);
  max-width: toRem(320);
  display: flex;
  align-items: center;
  text-align: start;
  padding: toRem(10) toRem(24);

  border-radius: 0.5rem;
  border: 0.855px solid #fff;
  background: linear-gradient(
      0deg,
      var(--Background-Bg-blurr-dark, rgba(34, 34, 34, 0.25)) 0%,
      var(--Background-Bg-blurr-dark, rgba(34, 34, 34, 0.25)) 100%
    ),
    var(--Background-Base, #040832);
  box-shadow: 1.711px 6.844px 21.386px 0 rgba(255, 255, 255, 0.2);
  &:hover {
    background: linear-gradient(
        0deg,
        var(--Background-Bg-blurr-light, rgba(255, 255, 255, 0.15)) 0%,
        var(--Background-Bg-blurr-light, rgba(255, 255, 255, 0.15)) 100%
      ),
      var(--Background-Base, #040832);
  }

  &-icon {
    min-width: toRem(24);
    min-height: toRem(24);
    margin-left: toRem(17);
  }

  .tablet &,
  .mobile & {
    padding: toRem(8);
    height: toRem(52);
    max-width: toRem(240);

    .link-button-icon {
      margin-left: 0;
    }
  }
}
</style>
